import KeyCabinetUniversal from 'containers/KeyCabinet/Universal'
import Settings from 'containers/Account/Settings/SettingsPage'
import { Switch, Redirect, Route } from 'react-router-dom'
import GateGateway from 'containers/entrance/GateGateway'
import Registration from 'containers/forms/Registration'
import SubWarehouse from 'containers/Warehouse/SubMenu'
import PaymentStatus from 'containers/PaymentStatus'
import OrderContract from 'containers/OrderContract'
import NewWarehouse from 'containers/NewWarehouse'
import FirstOpening from 'containers/FirstOpening'
import OrderDetails from 'containers/OrderDetails'
import OrderSummary from 'containers/OrderSummary'
import RestoreOrder from 'containers/RestoreOrder'
import OAuthFinish from 'containers/OAuth/Finish'
import Contract from 'containers/forms/Contract'
import Shared from 'containers/entrance/Shared'
import PayInvoice from 'containers/PayInvoice'
import Billing from 'containers/forms/Billing'
import MapDetails from 'containers/MapDetails'
import Categories from 'containers/Categories'
import KeyCabinet from 'containers/KeyCabinet'
import Warehouses from 'containers/Warehouses'
import Warehouse from 'containers/Warehouse'
import MapSearch from 'containers/MapSearch'
import Dashboard from 'containers/Dashboard'
import Google from 'containers/OAuth/Google'
import MagMobile from 'containers/MagMobile'
import PayExtra from 'containers/PayExtra'
import Apple from 'containers/OAuth/Apple'
import Reset from 'containers/forms/Reset'
import AccountRecovery from 'containers/forms/AccountRecovery'
import StartPage from 'layouts/StartPage'
import Payment from 'containers/Payment'
import Account from 'containers/Account'
import Login from 'containers/Login'
import Chats from 'containers/Chats'
import Shop from 'containers/Shop'
import Home from 'containers/Home'
import Maps from 'containers/Maps'
import Help from 'containers/Help'
import MRoute from './MRoute'

const type = process.env.REACT_APP_TYPE

const Router = () => {
  return (
    <Switch>
      <MRoute exact path='/' bottomBar showNotification isHeader={type !== 'box'} showHeaderOnlyIfUserIsLogIn={type === 'box'}>
        <StartPage />
      </MRoute>

      <MRoute exact path='/account/payments/extra' protectedPath>
        <PayExtra />
      </MRoute>

      <MRoute exact path='/account/settings' showNotification>
        <Settings />
      </MRoute>

      <MRoute exact path={['/account/:key/:action', '/account/:key', '/account']} bottomBar showNotification>
        <Account />
      </MRoute>

      <MRoute exact path='/categories' darkHeader={type !== 'box'} animation={false}>
        <Categories />
      </MRoute>

      <MRoute exact path='/chat/:id'>
        <Chats />
      </MRoute>

      <MRoute exact path='/chat' showNotification>
        <Chats />
      </MRoute>

      <MRoute exact path='/contract'>
        <Contract />
      </MRoute>

      <MRoute exact path='/dashboard' protectedPath bottomBar showNotification>
        <Dashboard />
      </MRoute>

      <Route exact path={['/firstopening/:id/:key', '/firstopening/:id']}>
        <FirstOpening />
      </Route>

      <MRoute exact path='/help' bottomBar>
        <Help />
      </MRoute>

      <MRoute exact path='/home' bottomBar showNotification isHeader={type !== 'box'} showHeaderOnlyIfUserIsLogIn={type === 'box'}>
        <Home showOptionalCategories />
      </MRoute>

      <MRoute exact path='/invoices/:id/pay'>
        <PayInvoice />
      </MRoute>

      <MRoute exact path='/keycabinet' animation={false} protectedPath showNotification>
        <KeyCabinetUniversal />
      </MRoute>

      <MRoute exact path='/login'>
        <Login />
      </MRoute>

      <MRoute exact path='/login/recovery'>
        <AccountRecovery />
      </MRoute>

      <MRoute exact path='/login/reset'>
        <Reset />
      </MRoute>

      {type === 'mm' && <MRoute exact path='/magmobile' darkHeader>
        <MagMobile />
      </MRoute>}

      <MRoute exact path={['/map/:placeId', '/map']} flyingHeader>
        <Maps />
      </MRoute>

      <Route exact path={['/mapsearch/:provinceIdx/:cityIdx', '/mapsearch/:provinceIdx', '/mapsearch']}>
        <MapSearch />
      </Route>

      <MRoute exact path='/mapdetails/:placeId' whiteHeader darkHeader animation={false}>
        <MapDetails />
      </MRoute>

      <Route exact path={['/newwarehouse/:key/:id', '/newwarehouse/:key', '/newwarehouse']}>
        <main>
          <NewWarehouse />
        </main>
      </Route>

      <Route exact path='/oauth/apple'>
        <main>
          <Apple />
        </main>
      </Route>

      <Route exact path='/oauth/google'>
        <main>
          <Google />
        </main>
      </Route>

      <Route exact path='/oauth/finish'>
        <main>
          <OAuthFinish />
        </main>
      </Route>

      <MRoute exact path='/odbior-klucza' animation={false} protectedPath showNotification>
        <KeyCabinetUniversal purpose='pickup' />
      </MRoute>

      <MRoute exact path='/order/billing' protectedPath>
        <Billing />
      </MRoute>

      <MRoute exact path='/order/contract'>
        <OrderContract />
      </MRoute>

      <MRoute exact path='/order/finalize/:cartId'>
        <RestoreOrder />
      </MRoute>

      <MRoute exact path='/order/payment'>
        <Payment />
      </MRoute>

      <MRoute exact path='/order/summary'>
        <OrderSummary />
      </MRoute>

      <MRoute exact path='/order/:id' darkHeader roundedHeader>
        <OrderDetails />
      </MRoute>

      <MRoute exact path={['/order/:cartId/equipment/:equipmentId/:categoryId', '/order/:cartId/equipment/:equipmentId', '/order/:cartId/shop/:categoryId', '/order/:cartId/shop', '/shop/:warehouseId', '/shop']} darkHeader animation={false}>
        <Shop />
      </MRoute>

      <MRoute exact path='/payment/status'>
        <PaymentStatus />
      </MRoute>

      <MRoute exact path='/registration'>
        <Registration />
      </MRoute>

      <Route exact path='/shared/:hash'>
        <main>
          <Shared />
        </main>
      </Route>

      <MRoute exact path='/warehouses' animation={false} protectedPath showNotification>
        <Warehouses />
      </MRoute>

      <MRoute exact path='/warehouses/:id' animation={false} protectedPath showNotification>
        <Warehouse />
      </MRoute>

      <MRoute exact path={['/warehouses/:id/gate', '/warehouses/:id/gateway']} animation={false} protectedPath showNotification>
        <GateGateway />
      </MRoute>

      <MRoute exact path='/warehouses/:id/keycabinet' animation={false} protectedPath showNotification>
        <KeyCabinet />
      </MRoute>

      <MRoute exact path={['/warehouses/:id/:type/:action/:typeId', '/warehouses/:id/:type/:action', '/warehouses/:id/:type']} animation={false} protectedPath showNotification>
        <SubWarehouse />
      </MRoute>

      <MRoute exact path='/zwrot-klucza' animation={false} protectedPath showNotification>
        <KeyCabinetUniversal purpose='return' />
      </MRoute>

      <Redirect to='/' />
    </Switch>
  )
}

export default Router